var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.element,{tag:"component",staticClass:"dumbapp-editable",class:{placeholder: _vm.showPlaceholder},attrs:{"contenteditable":"true"},on:{"focusin":_vm.focused,"focusout":_vm.unfocused,"input":_vm.input}},[_vm._v(_vm._s(_vm.currentValue || _vm.placeholder))])
}
var staticRenderFns = []

export { render, staticRenderFns }